<template>
    <div>
        <h1>{{ agreement.name }}</h1>
        <p>{{$t('Before continuing, you must read and accept the')}} "{{ agreement.name }}"</p>
        
        <div v-html="agreement.text" class="agreement_text"></div>
        <div class="mt-4">
            <b-form-checkbox autofocus v-model="is_accepted"> {{ $t('I accept the')}} "{{ agreement.name }}"</b-form-checkbox>
            <div class="mt-2">
                <b-button size="lg" @click="accept_agreement" variant="dark" :disabled="!is_accepted">{{ $t('Continue') }} &rarr;</b-button>
            </div>
            
        </div>
    </div>
</template>
<script>
export default{
    data(){
        return {
            agreement:{},
            is_accepted: false,
        }
    },
    props:{
        agreement_id:{
            required: false,
        }
    },
    async fetch(){
        await this.$axios.$get(`/${this.$i18n.locale}/api/agreements/${this.agreement_id}/`)
            .then(r=>{
                this.agreement = r
                if(this.agreement.is_accepted){
                    this.redirect()
                }
            })
    },
    methods:{
        redirect(){
            this.$router.push(this.localePath('/'))
        },
        accept_agreement(){
            this.$axios.$post(`/${this.$i18n.locale}/api/agreements/${this.agreement_id}/accept/`)
                .then(r=>{
                    this.$auth.fetchUser().then(
                        ()=>{this.redirect()}
                    )
                    
                })
                .catch(e=>{
                    this.redirect()
                })
        }
    },
    i18n:{
        messages:{
            ru:{
                'Continue': 'Продолжить',
                'I accept the': 'Я принимаю',
                'Before continuing, you must read and accept the': 'Перед тем, как продолжить, вы должны прочитать и принять',
            }
        }
    }
}
</script>
<style lang="scss">
.agreement_text{
    border: 1px solid gray;
    overflow-y: scroll;
    height: 50vh;
    padding: 0.5rem
}
</style>